import { useQuery } from '@tanstack/react-query';
import type { Event } from '@casetrace/shared';
import { fetchCaseEvent } from './use-case-event';

export function useEventPreview(caseId: string, event: Event | null, enabled: boolean) {
  const shouldFetch = enabled && Boolean(caseId) && Boolean(event?.id);
  const query = useQuery({
    queryKey: ['event-preview', caseId, event?.id] as const,
    queryFn: () => fetchCaseEvent(caseId, event!.id),
    enabled: shouldFetch,
    staleTime: 60_000,
  });

  return query.data ?? event;
}
